<template>
  

    <div class="radioContainer">
        <div class="form-check">
            <label class="form-check-label" @click="this.$refs.trueRadio.click();">
                <input class="form-check-input" type="radio" :name="inputId" id="flexRadioDefault1" v-model="myModel" :value="true" @blur="this.$emit('blur')" @change="update" ref="trueRadio">
                {{boolTrueText}}
            </label>
        </div>

        <div class="form-check">
            <label class="form-check-label" @click="this.$refs.falseRadio.click();">
                <input class="form-check-input" type="radio" :name="inputId" id="flexRadioDefault2" v-model="myModel" :value="false" @blur="this.$emit('blur')" @change="update" ref="falseRadio">
                {{boolFalseText}}
            </label>
        </div>
    </div>
    
    <div class="errorMessageForm" v-for="error of myErrors" :key="error.$uid">
        {{error.$message}}
    </div>

</template>

  
<script>
export default {
    name: "RadioBoolInput",
    props: {
        inputId:String,
        labelText:String,
        inputVModel: {},
        objectKey:String,
        boolTrueText:String,
        boolFalseText:String,
        myErrors:[]
    },
    data() {
        return {
            myModel:''
        };
    },
    mounted(){
        this.myModel = this.inputVModel; 
        //console.log("my model: ",this.myModel);
    },
    methods:{
        update(){
            this.$emit("UpdateForm", this.objectKey, this.myModel);
        }
    },
    watch:{
        inputVModel(newVal,oldVal){
            //console.log("old value: ", oldVal, "new value: ", newVal);
            oldVal;
            this.myModel = newVal;
        }
    },
};
</script>

<style>
.radioContainer{
    width:100%;
    display:inline-block;
    text-align:left;
}
</style>